import { request } from '@/shared/api/request'

export const getEmployerRequests = ({ srcText = '', page = 0, size = 50 }) =>
	request({ url: `contract/persCard/searchReq?srcText=${srcText}&page=${page}&size=${size}`, method: 'GET' })
